import { Controller } from 'stimulus';

// Calendar settings shortcut modal: saves the default batch color config, then reloads the
// page so the schedule board re-renders with the new color. Keeps the current URL/filters.
export default class extends Controller {
  static values = { url: String };
  static targets = ['submit'];

  save(event) {
    event.preventDefault();

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    this.disableSubmit();

    fetch(this.urlValue, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(this.element)
    })
      .then((response) => {
        if (response.ok) {
          window.location.reload();
        } else {
          this.enableSubmit();
          window.alert('Não foi possível salvar as configurações.');
        }
      })
      .catch(() => {
        this.enableSubmit();
        window.alert('Não foi possível salvar as configurações.');
      });
  }

  disableSubmit() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }

  enableSubmit() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
  }
}
